<div class="c-richClub">
  <slotcom-navigation-button
    type="close"
    rightPosition="5"
    (click)="closeModal()"></slotcom-navigation-button>

  <div class="c-richClub__container">
    <div class="c-richClub-icon"></div>

    <div class="c-richClub__info">
      <div class="c-richClub__text">
        <span class="text title">{{ 'home.modals.rich-club.bonus-available.title' | translate | uppercase }} </span>
        <span class="text subtitle"> {{ 'home.modals.rich-club.bonus-available.subtitle' | translate }}</span>
      </div>
    </div>

    <slotcom-button
      class="c-button--pink"
      (safeClick)="openAppchargeLanding()"
      audioType="payment">
      <span class="label">
        {{ 'common.want-it' | translate | uppercase }}
      </span>
    </slotcom-button>
  </div>
</div>
